import { Component, inject, Input, OnInit } from '@angular/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { SummaryListComponent } from '../../summary-list/feature/summary-list.component';
import { EventSystemBasic } from '../../../data-services/models/event-systems/event-system-basic.model';
import { Store } from '@ngrx/store';
import { selectAllEvents } from '../../../data-services/stores/selectors/events.selectors';
import { EventActions } from '../../../data-services/stores/actions/events.actions';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from '../../../loading/feature/loading.component';
import { selectAllEventSystems } from '../../../data-services/stores/selectors/event-systems.selectors';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EventSystemActions } from '../../../data-services/stores/actions/event-system.actions';
import { EventSystemDetailed } from '../../../data-services/models/event-systems/event-system-detailed.model';
import { BoilerplateComponent } from '../../../core/boilerplate/feature/boilerplate.component';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-events-upcoming',
    imports: [BoilerplateComponent, MultiSelectModule, SummaryListComponent, CommonModule, LoadingComponent, ReactiveFormsModule],
    templateUrl: '../ui/upcoming.component.html',
    styleUrl: '../ui/upcoming.component.css'
})
export class EventsUpcomingComponent implements OnInit {
  private readonly _store = inject(Store);
  private readonly _titleService = inject(Title);
  events$ = this._store.select(selectAllEvents);
  eventSystems$ = this._store.select(selectAllEventSystems);
  @Input() eventSystem?: EventSystemBasic;
  formGroup: FormGroup = new FormGroup({
    selectedEventSystems: new FormControl<EventSystemDetailed[] | null>([])
  })

  ngOnInit(): void {
    this._store.dispatch(EventActions.loadAllUpcomingEvents());
    this._store.dispatch(EventSystemActions.loadEventSystems());
    this._titleService.setTitle('LRPTickets.co.uk | Upcoming Events')
  }
}
